import { combineReducers } from 'redux'

import user from './user'

export const reducer = combineReducers({
  user: user.reducer,
})

export default reducer
